export const PERMISSIONS = {
  // Voice
  CALL_SVC_BASE: "CALL_VO1",

  // Team Lead
  CALL_SVC_TEAM_LEAD_BASE: "CALL_TL1",

  // Admin
  CALL_SVC_ADMIN_BASE: "CALL_AD1",
  CALL_CALL_DETAIL_ACTIONS: "CALL_AD2",

  // Calendar (legacy)
  CALL_CALENDAR_CREATE: "CALL_CA1",
  CALL_CALENDAR_UPDATE: "CALL_CA2",
  CALL_CALENDAR_DELETE: "CALL_CA3",
  CALL_CALENDAR_READ: "CALL_CA4",

  CALL_CALENDAR_PLAN_CREATE: "CALL_CP1",
  CALL_CALENDAR_PLAN_READ: "CALL_CP2",
  CALL_CALENDAR_PLAN_DELETE: "CALL_CP3",
  CALL_CALENDAR_PLAN_UPDATE: "CALL_CP4",

  // Event types
  CALL_EVENT_TYPE_READ: "CALL_ET1",
  CALL_EVENT_TYPE_CREATE: "CALL_ET2",
  CALL_EVENT_TYPE_UPDATE: "CALL_ET3",
  CALL_EVENT_TYPE_DELETE: "CALL_ET4",

  // Setting
  CALL_SETTING_PRIORITY_COUNTS: "CALL_SP1", // GET /setting/priority-counts
  CALL_SETTING_PRIORITY_READ_LEADS: "CALL_SP3", // Priority report leads list

  // QW
  CALL_QUALITY_WATCH_READ_EVALUATION: "CALL_QW1", // GET /quality-watch

  // Agent performance dashboard
  CALL_DASHBOARD_AGENT_PERFORMANCE: "CALL_DP1",

  // Incidents
  INCIDENT_REPORT_NOTES: "CALL_IN1", // GET/POST /incident-reports/:id/notes

  // Performance reports
  CALL_REPORTS_PRP_ADMIN: "CALL_RP1",
  CALL_REPORTS_SALES_ADMIN: "CALL_RS1",

  // Strings (app-svc)
  APP_STRINGS_LIST: "APP_ST1",
  APP_STRINGS_CREATE: "APP_ST2",
  APP_STRINGS_UPDATE: "APP_ST3",
  APP_STRINGS_DELETE: "APP_ST4",
  APP_STRINGS_EXPORT: "APP_ST5",
  APP_STRINGS_IMPORT: "APP_ST6",
  APP_STRINGS_PUBLISH: "APP_ST7",

  // Auth users (auth-svc)
  AUTH_SVC_AUTH_REGISTER: "AUTH1",
  AUTH_SVC_PERMISSIONS_CODES_LIST: "AUTH8",
  AUTH_SVC_PERMISSIONS_GROUPS_LIST: "AUTH9",
  AUTH_SVC_PERMISSIONS_GROUPS_FIND: "AUTH10",
  AUTH_SVC_PERMISSIONS_GROUPS_CREATE: "AUTH11",
  AUTH_SVC_PERMISSIONS_GROUPS_UPDATE: "AUTH12",
  AUTH_SVC_PERMISSIONS_GROUPS_DELETE: "AUTH13",
  AUTH_SVC_USER_LIST: "AUTH15",
  AUTH_SVC_USER_FIND: "AUTH16",
  AUTH_SVC_USER_UPDATE: "AUTH17",
  AUTH_SVC_USER_DELETE: "AUTH18",
  AUTH_SVC_API_KEYS_VIEW: "AUTH19",
  AUTH_SVC_API_KEYS_MANAGE: "AUTH20",
};
